import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface KbdProps extends HTMLAttributes<HTMLElement> {
  /** sm: 10px inline hint · md: 11px key cap (default) · lg: 11px key cap with more padding. */
  size?: 'sm' | 'md' | 'lg';
  /** `inverse` is used inside dark tooltips / toasts. */
  variant?: 'default' | 'inverse';
}

/** Keyboard-hint chip, e.g. <Kbd>⌘K</Kbd>. Always LTR. */
export const Kbd = forwardRef<HTMLElement, KbdProps>(function Kbd(
  { size = 'md', variant = 'default', className, children, ...rest },
  ref,
) {
  return (
    <kbd
      ref={ref}
      dir="ltr"
      className={cn(
        'inline-flex items-center font-mono leading-4 whitespace-nowrap',
        variant === 'inverse'
          ? 'rounded-[3px] border border-[color-mix(in_srgb,currentColor_30%,transparent)] px-[5px] text-10'
          : size === 'sm'
            ? 'rounded-[3px] border border-border px-[5px] text-10 text-text-3'
            : cn(
                'rounded-sm border border-b-2 border-border bg-surface px-1.5 text-11 text-text-2',
                size === 'lg' ? 'py-0.5' : 'py-px',
              ),
        className,
      )}
      {...rest}
    >
      {children}
    </kbd>
  );
});
